<template>
  <page-outline
    :title="$t('tracking.tracks_bulk_details')"
    :show-extract="hasLinesData"
    :extract-disabled="activateSpinner"
    :extract-text="$t('common.extract_lines')"
    @extract="exportLinesCSV">
    <template slot="primaryActions">
      <app-button
        :text="$t('common.bck')"
        icon="fa-light fa-arrow-left"
        variant="primary"
        @click="goBack">
      </app-button>
    </template>
    <template slot="pageContent">
      <b-container fluid>

        <spinner v-if="activateSpinner"></spinner>
        <template v-else-if="Tracking">
          <div>
            <form-accordion :title="$t('tracking.file_information')" :isTitleUpperCase="false">
              <b-row class="form-group justify-content-start">
                <!-- Première ligne -->
                <b-col sm="4" class="mb-4">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.silo')"
                    :inputValue="Tracking.Silo || '-'">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-4">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.reception_date')"
                    :inputValue="Tracking.Date ? getDateDay(Tracking.Date) : '-'">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-4">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.file_type')"
                    :inputValue="getFileType(Tracking.FileType)">
                  </form-read-group-label-input>
                </b-col>

                <!-- Deuxième ligne -->
                <b-col sm="4" class="mb-4">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.entity_emitter')"
                    :inputValue="Tracking.bic_from || '-'">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-4">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.bic_billable')"
                    :inputValue="Tracking.bic_facturable || '-'">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-4">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.file_name')"
                    :inputValue="Tracking.FileName || '-'">
                  </form-read-group-label-input>
                </b-col>

                <!-- Troisième ligne -->
                <b-col sm="4" class="mb-4">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.nb_requests')"
                    :inputValue="String(Tracking.NbRequests || 0)">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-4">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.nb_requests_ok')"
                    :inputValue="String(Tracking.NbRequestsOK || 0)">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-4">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.nb_requests_error')"
                    :inputValue="String(Tracking.NbRequestsKO || 0)">
                  </form-read-group-label-input>
                </b-col>

                <!-- Quatrième ligne -->
                <b-col sm="4" class="mb-4">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.final_status')"
                    :inputValue="translateStatus(Tracking.FinalStatus)">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-4">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.processing_state')"
                    :inputValue="translateStatusFile(Tracking.StatusFile)">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-4">
                  <label id="" class="">{{ $t('tracking.file') }}</label>
                  <div class="d-flex justify-content-start align-item-start">
                    <div>
                      <i class="fa fa-eye cursor pl-2 pr-1 color-var-actionButtonColorBlue" @click="seeJson(Tracking.idTrackingBulk, 'trackingBulk', 'see')"></i>
                    </div>
                    <div>
                      <i class="fa fa-download cursor px-2 color-var-actionButtonColorBlue" @click="seeJson(Tracking.idTrackingBulk, 'trackingBulk', 'download')"></i>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </form-accordion>
          </div>
          <hr />
          <div>
            <form-accordion :title="$t('tracking.lines')" :isTitleUpperCase="false">
              <!-- <b-table
                :items="Tracking.Lines"
                :fields="fields"
                class="table table-striped" v-if="Tracking.Lines && Tracking.Lines.length"
                :selectable="Tracking.Lines.length > 0"
                @row-selected="seeTracksBulkDetails">

                <template #cell(Status)="data">
                  <span><i :class="calculateStatuses(data.item)"></i></span>
                </template>
              </b-table> -->
              <div v-if="TracksList.length > 0" style="overflow:auto">
                <b-table
                  hover
                  class="table table-striped mb-0"
                  :fields="fieldsTrack"
                  :items="TracksList"
                  :selectable="TracksList.length > 0"
                  :empty-text="$t('common.security.no_result')"
                  @row-clicked="handleRowClicked"
                  role="table"
                  sticky-header
                  >
                  <template #cell(idMsg)="data">
                    <span>{{ displayValue(data.value) }}</span>
                  </template>

                  <template #cell(CreationDateRq1)="data">
                    <span>{{ displayValue(getDateDay(data.value)) }}</span>
                  </template>

                  <template #cell(CreationDateRp2)="data">
                    <span>{{ displayValue(getDateDay(data.value)) }}</span>
                  </template>

                  <template #cell(BICFrom)="data">
                    <span>{{ displayValue(data.value) }}</span>
                  </template>

                  <template #cell(BICTo)="data">
                    <span>{{ displayValue(data.value) }}</span>
                  </template>

                  <template #cell(IBAN)="data">
                    <span>{{ displayValue(data.value) }}</span>
                  </template>

                  <template #cell(Name)="data">
                    <span>{{ displayValue(data.item.Name) }}</span>
                  </template>

                  <template #cell(Siren)="data">
                    <span>{{ displayValue(data.item.Siren) }}</span>
                  </template>

                  <template #cell(Siret)="data">
                    <span>{{ displayValue(data.item.Siret) }}</span>
                  </template>

                  <template #cell(TVAIntracom)="data">
                    <span>{{ displayValue(data.item.TVAIntracom) }}</span>
                  </template>

                  <template #cell(TestedData)="data">
                    <span v-if="data.item.Name">{{ displayValue(data.item.Name) }}</span>
                    <span v-else-if="data.item.Siren">{{ displayValue(data.item.Siren) }}</span>
                    <span v-else-if="data.item.Siret">{{ displayValue(data.item.Siret) }}</span>
                    <span v-else-if="data.item.TVAIntracomm">{{ displayValue(data.item.TVAIntracomm) }}</span>
                    <span v-else-if="data.item.LEI">{{ displayValue(data.item.LEI) }}</span>
                    <span v-else-if="data.item.EUID">{{ displayValue(data.item.EUID) }}</span>
                    <span v-else>-</span>
                  </template>

                  <template #cell(Result)="data">
                    <span>{{ displayValue(data.item.Business_status) }}</span>
                  </template>

                  <template #cell(TechStatusCode)="data">
                    <span v-if="data.item.TechStatusCode !== ''">
                      {{ displayValue(translateTechStatusCode(data.item.TechStatusCode)) }}
                    </span>
                    <span v-else>
                      {{ displayValue($t('common.monitoring.success')) }}
                    </span>
                  </template>

                  <template #cell(ReasonCodeAll)="data">
                    <span v-if="data.item.ReasonCodeEntity">
                      {{ displayValue($t('tracking.flagCACP.reason_code_optional_entity_list.' + data.item.ReasonCodeEntity)) }}
                    </span>
                    <span v-else>-</span>
                  </template>
                </b-table>
              </div>
              <div v-else class="d-flex justify-content-center">
                <span class="noResult">
                  {{ $t('common.no_result') }}
                </span>
              </div>
            </form-accordion>
          </div>
          <hr/>
          <div>
            <form-accordion :title="$t('tracking.history')" :isTitleUpperCase="false">
              <table class="table table-striped" v-if="Tracking.History && Tracking.History.length">
                <tbody>
                  <tr>
                    <th class="text-center w-25">
                      {{ $t('tracking.status') }}
                    </th>
                    <th class="text-center w-25">
                      {{ $t('tracking.status_code') }}
                    </th>
                    <th class="text-center w-25">
                      {{ $t('tracking.processing_date') }}
                    </th>
                  </tr>
                  <tr v-for="history in Tracking.History" :key="history.id">
                    <td class="text-center w-25">
                      <div v-if="history.Status !== ''">{{ $t('tracking.status-' + history.Status) }}</div>
                    </td>
                    <td class="text-center w-25">
                      <div v-if="history.StatusCode !== ''">{{ translateTechStatusCode(history.StatusCode) }}</div>
                    </td>
                    <td class="text-center w-25">
                      {{ getDate(history.Date) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </form-accordion>
          </div>

        </template>
      </b-container>
    </template>
  </page-outline>
</template>

<script>
import PageOutline from '@/components/common/PageOutline.vue'
import AppButton from '@/components/common/AppButton.vue'
import Spinner from '@/components/common/spinner.vue'
import formAccordion from "@/components/common/FormAccordion.vue";
import FormReadGroupLabelInput from "@/components/common/formReadGroupLabelInput.vue";
import {errorMessageAlert} from "@/helpers/alert";
import { downloadFileWithDefinedHeaders } from '@/helpers/download'
import moment from "moment-timezone";
import {DOMParser} from "xmldom";
import TrackingPage from "@/pages/tracking/TrackingPage.vue";
import {loadPage} from "@/helpers/routing";

export default {
  name: 'TrackingBulkDetails',
  components: {
    TrackingPage,
    FormReadGroupLabelInput,
    'page-outline': PageOutline,
    AppButton,
    'spinner': Spinner,
    'form-accordion': formAccordion,
  },
  computed: {
    hasLinesData () {
      return this.TracksList && this.TracksList.length > 0
    },
    // fields () {
    //   let fields
    //   fields = [
    //     { key: 'idMsg', label: this.$i18n.t('tracking.id_track'), class: 'text-center', sortable: false },
    //     //{ key: 'CreationDateRq1', label: this.$i18n.t('tracking.creation_date_request_1'), thClass: 'min-w-160px', class: 'text-center', sortable: false },
    //     //{ key: 'CreationDateRp2', label: this.$i18n.t('tracking.creation_date_response_2'), class: 'text-center', sortable: false },
    //     { key: 'BICFrom', label: this.$i18n.t('tracking.bic_from'), class: 'text-center', sortable: false },
    //     { key: 'BICTo', label: this.$i18n.t('tracking.bic_to'), class: 'text-center', sortable: false },
    //     { key: 'IBAN', label: this.$i18n.t('tracking.iban'), class: 'text-center', sortable: false },
    //     { key: 'Status', label: this.$i18n.t('tracking.status'), class: 'text-center', sortable: false },
    //     { key: 'Name', label: this.$i18n.t('tracking.name'), class: 'text-center', sortable: false },
    //     { key: 'MatchedName', label: this.$i18n.t('tracking.matched_name'), class: 'text-center', sortable: false },
    //     { key: 'TestedData', label: this.$i18n.t('tracking.tested_data'), class: 'text-center', sortable: false },
    //     { key: 'Result', label: this.$i18n.t('tracking.maching_result'), class: 'text-center', sortable: false },
    //     { key: 'TechStatusCode', label: this.$i18n.t('tracking.technical_code'), class: 'text-center', sortable: false }
    //
    //
    //   ]
    //
    //   return fields
    // },
    fieldsTrack () {
      let fields
        fields = [
          { key: 'idMsg', label: this.$i18n.t('tracking.id_track'), class: 'text-center', sortable: false },
          { key: 'CreationDateRq1', label: this.$i18n.t('tracking.creation_date_request_1'), class: 'text-center', sortable: false },
          { key: 'CreationDateRp2', label: this.$i18n.t('tracking.creation_date_response_2'), class: 'text-center', sortable: false },
          { key: 'BICFrom', label: this.$i18n.t('tracking.bic_from'), class: 'text-center', sortable: false },
          { key: 'BICTo', label: this.$i18n.t('tracking.bic_to'), class: 'text-center', sortable: false },
          { key: 'IBAN', label: this.$i18n.t('tracking.iban'), class: 'text-center', sortable: false },
          { key: 'Name', label: this.$t('tracking.name'), class: 'text-center', sortable: false },
          { key: 'Siren', label: this.$i18n.t('tracking.siren'), class: 'text-center', sortable: false },
          { key: 'Siret', label: this.$i18n.t('tracking.siret'), class: 'text-center', sortable: false },
          { key: 'TVAIntracom', label: this.$i18n.t('tracking.tva_intracom'), class: 'text-center', sortable: false },
          { key: 'TestedData', label: this.$t('tracking.tested_data'), class: 'text-center', sortable: false },
          { key: 'Result', label: this.$t('tracking.maching_result'), class: 'text-center', sortable: false },
          { key: 'TechStatusCode', label: this.$t('tracking.flagCACP.demande_status'), class: 'text-center', sortable: false },
          { key: 'ReasonCodeAll', label: this.$i18n.t('tracking.flagCACP.reason_code'), class: 'text-center', sortable: false }
          // { key: 'CompanyName', label: this.$i18n.t('tracking.company_name'), class: 'text-center', sortable: true },
          // { key: 'Siret', label: this.$i18n.t('tracking.siret'), class: 'text-center', sortable: true },
          // { key: 'TVA', label: this.$i18n.t('tracking.tva'), class: 'text-center', sortable: true },
          // { key: 'AccountType', label: this.$i18n.t('tracking.account_type'), class: 'text-center', sortable: true },
        ]
      return fields
    },
    canUserDelete () {
      return this.$engine.get(this.engineIndex).rights.rightIs('usercompany_delete', true) || this.$engine.get(this.engineIndex).rights.rightIs('usercompany_delete_admin', true)
    },
    canUserEdit () {
      return this.$engine.get(this.engineIndex).rights.rightIs('usercompany_edit', true) || this.$engine.get(this.engineIndex).rights.rightIs('usercompany_edit_admin', true)
    },
    listTitle () {
      return 'Details de l\'utilisateur'
    }
  },
  props: ['id', 'engineIndex'],
  data () {
    return {
      timezone: '+00:00',
      activateSpinner: false,
      returnUrl: '',
      Tracking: {},
      TracksList: [],
      allLinesMerged: [],
      paginationObject: {
        firstIndex: 1,
        maxResults: 15,
        nbResultsTotal: 0,
        refresh: ''
      }
    }
  },
  created () {
    this.timezone = moment.tz.guess()

    //this.defineReturnURL()
    this.returnUrl = 'none'
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: 'Details de l\'utilisateur',
      // returnUrl: ''
    })

    this.fetchBulkDetailAndMerge()
    this.$f7.initPullToRefresh()
    this.pageCounter = 0


    this.filterTypeGet = this.filterType
    this.$bus.$emit('right-panel-set-feature', 'filter-messages')
  },
  beforeDestroy () {
    const engines = this.$engine?.engines ?? []
    for (let i = 0; i < engines.length; i++) {
      const engine = this.$engine.get(i)
      if (engine && engine.common?.network?.state !== 'offline' && engine?.tracking?.cleanFilterCondition) {
        engine.tracking.cleanFilterCondition()
      }
    }
  },
  methods: {
    goBack () {
      // Toujours réutiliser la page précédente (et donc ses listeners)
      if (this.$f7?.mainView?.router?.back) {
        this.$f7.mainView.router.back()
        this.$bus.$emit('router-back')
      } else {
        // vrai fallback seulement si nécessaire
        loadPage(this, { url: '/home/' })
      }
    },
    async fetchBulkDetailAndMerge() {
      this.activateSpinner = true;

      const engines = this.$engine?.engines ?? [];
      let bestHeader = null;
      let mergedLines = [];

      for (let i = 0; i < engines.length; i++) {
        const engine = this.$engine.get(i);
        if (!engine || engine.common?.network?.state === 'offline') continue;
        if (!engine?.tracking?.getTracksBulk) continue;

        try {
          const resp = await engine.tracking.getTracksBulk({ IdTrackBulk: this.id });
          const list = resp?.data?.trackingBulk || [];
          if (!list.length) continue;

          const header = list[0];

          // Choisir le header le plus récent (ou le premier trouvé)
          if (!bestHeader) {
            bestHeader = { ...header, engineIndex: i };
          } else {
            const dNew = new Date(header?.Date || 0).getTime();
            const dBest = new Date(bestHeader?.Date || 0).getTime();
            if (dNew > dBest) bestHeader = { ...header, engineIndex: i };
          }

          // Tag des lignes
          const lines = (header.Lines || []).map(l => ({ ...l, engineIndex: i }));
          mergedLines.push(...lines);

        } catch (error) {
          errorMessageAlert(error, this);
        }
      }

      // Déduplication (idMsg / IdVopMessage / fallback)
      const map = new Map();
      for (const l of mergedLines) {
        const key =
          l.IdVopMessage ||
          l.idMsg ||
          l.IdMsg ||
          `${l.CreationDateRq1 || ''}-${l.IBAN || ''}-${l.BICFrom || ''}-${l.BICTo || ''}`;
        if (!map.has(key)) map.set(key, l);
      }
      const unique = [...map.values()];

      // Tri (date desc)
      unique.sort((a, b) => {
        const da = new Date(a?.CreationDateRq1 || a?.CreationDate || 0).getTime();
        const db = new Date(b?.CreationDateRq1 || b?.CreationDate || 0).getTime();
        return db - da;
      });

      // stocker la fusion complète pour l’export
      this.allLinesMerged = unique;

      // Pagination locale (si besoin)
      this.paginationObject.nbResultsTotal = unique.length;
      //const page = unique.slice(0, this.paginationObject.maxResults);
      //this.paginationObject.nbResults = page.length;

      this.Tracking = bestHeader || {};
      //this.TracksList = page;
      this.TracksList = unique;

      this.activateSpinner = false;
    },
    displayValue(value) {
      return value !== undefined && value !== null && value !== '' ? value : '-';
    },

    activateDetail (id, engineIndex) {
      let that = this
      loadPage(that, {url: 'trackingdetails/DDV/' + id + '/' + this.engineIndex})
    },
    activateDetailBulk (id) {
      let that = this
      loadPage(that, {url: '/tracking/BULKDETAILS/' + id})
    },
    canViewDetails () {
      return this.$engine.get(this.engineIndex).rights.rightIs('tracking_bulk_details', true)
      //return this.$engine.firstOn().rights.rightIs('tracking_bulk_details', true)
    },
    handleRowClicked (item) {
      if (this.canViewDetails()) {
        this.seeTracksDetails(item)
      }
    },
    seeTracksDetails (item) {
      const id = item.IdVopMessage || item.idMsg || item.IdMsg
      const idx = Number.isInteger(item.engineIndex)
        ? item.engineIndex             // ligne fusionnée d’un autre silo
        : Number(this.engineIndex)     // fallback: silo du header (route)
      if (id != null) this.activateDetail(id, idx)
    },
    seeTracksBulkDetails (items) {
      this.activateDetailBulk(items[0].IdVopMessageLineBulk)
    },
    getStatus(value, score) {
      if (value && score == 'MTCH') {
        return 'MTCH';
      } else if (value && score == 'NCTC') {
        return 'NCTC';
      } else if (value && score == 'NOAP') {
        return 'NOAP';
      } else if (value && score == 'CMTC'){
        return 'CMTC';
      } else {
        return null;
      }
    },
    calculateStatuses(line) {
      // Définit les statuts pour chaque champ
      const statuses = {
        Name: this.getStatus(line.Name, line.NameScore),
        Siren: this.getStatus(line.Siren, line.SirenScore),
        Siret: this.getStatus(line.Siret, line.SiretScore),
        TVAIntracom: this.getStatus(line.TVAIntracom, line.TVAIntracomScore),
      }

      // Calcule le statut global
      const uniqueStatuses = new Set(Object.values(statuses))

      let globalStatus = null
      if (uniqueStatuses.has('NCTC')) {
        globalStatus = 'NCTC'
      } else if (uniqueStatuses.has('NOAP') || uniqueStatuses.has('CMTC')) {
        globalStatus = 'NOAP'
      } else {
        globalStatus = 'MTCH'
      }

      if (globalStatus == 'MTCH'){
        return "fa-solid fa-check text-success"
      }
      if (globalStatus == 'NCTC'){
        return "fa-solid fa-xmark text-danger"
      }
      if (globalStatus == 'NOAP'){
        return "fa-solid fa-triangle-exclamation text-warning"
      }
      if (globalStatus == null){
        return "fa-solid fa-ban"
      }
    },
    isXML (str) {
      try {
        const parser = new DOMParser()
        const jsonDoc = parser.parseFromString(str, 'text/xml')
        return jsonDoc.documentElement.nodeName !== 'parsererror'
      } catch (e) {
        return false
      }
    },
    isJSON (str) {
      try {
        JSON.parse(str);
        return true;
      } catch (e) {
        return false;
      }
    },
    isCSV(str) {
      const lines = str.split('\n')
      return lines.length > 1 && lines[0].includes(';')
    },
    async seeJson (IdMsg, service, action) {
      const tryOrder = []
      if (Number.isInteger(this.Tracking?.engineIndex)) tryOrder.push(this.Tracking.engineIndex)
      const engines = this.$engine?.engines ?? []
      for (let i = 0; i < engines.length; i++) if (!tryOrder.includes(i)) tryOrder.push(i)

      let respOK = null
      for (const i of tryOrder) {
        const engine = this.$engine.get(i)
        if (!engine || engine.common?.network?.state === 'offline' || !engine?.tracking?.getJSON) continue
        try {
          const resp = await engine.tracking.getJSON({ service, id: IdMsg })
          if (resp?.data) { respOK = resp; break }
        } catch (_) {}
      }
      if (!respOK) { errorMessageAlert({ message: 'No data' }, this); return }

      const dataB64 = respOK.data?.data
      const dataStr = Buffer.from(dataB64, 'base64').toString('utf-8')

      if (action === 'see') {
        this.$bus.emit('popup-json-details', { data: dataStr, type: service })
        return
      }

      // --- download ---
      const makeAndDownload = (mime, ext, i18nKey) => {
        const fileName = moment().format('YYYYMMDD_hhmmss_') + service + '.' + ext
        const blob = new Blob([dataStr], { type: mime })
        downloadFileWithDefinedHeaders(this, fileName, URL.createObjectURL(blob))
        this.$f7.alert('', this.$i18n.t(i18nKey))
      }

      if (this.isXML(dataStr))  return makeAndDownload('text/xml', 'xml', 'common.xml_downloaded')
      if (this.isJSON(dataStr)) return makeAndDownload('application/json', 'json', 'common.json_downloaded')
      if (this.isCSV(dataStr))  return makeAndDownload('text/csv', 'csv', 'common.csv_downloaded')

      // fallback inconnu
      makeAndDownload('application/octet-stream', 'txt', 'common.csv_downloaded')
    },


    getDateDay (date) {
      if (!date) return '-';

      // Si la date ne contient pas un offset explicite (+00:00, +04:00, etc.) ou 'Z', on suppose qu'elle est en UTC
      const hasTimezone = /([+-]\d{2}:\d{2}|Z)$/.test(date);
      const isoWithTZ = hasTimezone ? date : date + 'Z';

      return moment(isoWithTZ).tz(this.timezone).format('DD/MM/YYYY HH:mm:ss.SSS');
    },
    getDate (date) {
      if (!date) return '-';

      // Si la date ne contient pas un offset explicite (+00:00, +04:00, etc.) ou 'Z', on suppose qu'elle est en UTC
      const hasTimezone = /([+-]\d{2}:\d{2}|Z)$/.test(date);
      const isoWithTZ = hasTimezone ? date : date + 'Z';

      return moment(isoWithTZ).tz(this.timezone).format('DD/MM/YYYY HH:mm:ss.SSS');
    },
    translateTechStatusCode (code) {
      if (this.$t('tracking.error-status.' + code) !== 'tracking.error-status.' + code) {
        return this.$t('tracking.error-status.' + code)
      } else {
        return this.$t('tracking.error-status.default', { statusCode: code })
      }
    },
    getFileType(type) {
      if (!type) return '-';

      const typeMap = {
        'VIREMENT_INST': this.$t('tracking.file_type_virement_inst'),
        'SCT': this.$t('tracking.file_type_sct'),
        'SEPA': this.$t('tracking.file_type_sct'),
        'INST': this.$t('tracking.file_type_virement_inst')
      };

      return typeMap[type] || type;
    },
    translateStatus(status) {
      if (!status) return '-';

      const statusMap = {
        'PROCESSED': this.$t('tracking.final_status_processed'),
        'ERROR': this.$t('tracking.final_status_error'),
        'SUCCESS': this.$t('tracking.final_status_processed'),
        'FAILED': this.$t('tracking.final_status_error')
      };

      return statusMap[status] || status;
    },
    translateStatusFile(status) {
      const key = `tracking.status-${status}`;
      const translation = this.$t(key);

      if (translation === key) {
        return status || '-';
      }

      return translation;
    },
    defineReturnURL () {
      this.returnUrl = '/tracking/BULK/NULL'
    },
    // getTrack () {
    //   this.pageCounter = 0
    //   this.activateSpinner = true
    //   let that = this
    //   that.$engine.get(this.engineIndex).usercompany.idUserAcc = this.idUserAcc
    //   this.UsersList = []
    //   let filterConditions = {
    //     IdTrackBulk: this.id
    //   }
    //   that.$engine.get(this.engineIndex).tracking.getTracksBulk(
    //     filterConditions
    //   )
    //   .then(resp => {
    //     let requests = {}
    //     if (resp.data && resp.data.trackingBulk && resp.data.trackingBulk.length) {
    //       that.Tracking = resp.data.trackingBulk[0]
    //     }
    //     this.activateSpinner = false
    //   })
    //   .catch(error => {
    //     this.activateSpinner = false
    //     errorMessageAlert(error, that, that.$i18n)
    //   })
    // },
    // getTrack () {
    //   this.pageCounter = 0
    //   this.activateSpinner = true
    //   let that = this
    //
    //   let filterConditions = {
    //     IdTrackBulk: this.id
    //   }
    //
    //   that.$engine.get(this.engineIndex).tracking.getTracksBulk(filterConditions)
    //     .then(resp => {
    //       if (resp.data && resp.data.trackingBulk && resp.data.trackingBulk.length) {
    //         that.Tracking = resp.data.trackingBulk[0]
    //         that.TracksList = that.Tracking.Lines || []
    //       }
    //       this.activateSpinner = false
    //     })
    //     .catch(error => {
    //       this.activateSpinner = false
    //       errorMessageAlert(error, that, that.$i18n)
    //     })
    // },
    // getTracks() {
    //   let that = this
    //   this.pageCounter = 0
    //
    //   this.activateSpinner = true
    //
    //   let filterConditions = {
    //     Type: 'DDV'
    //   }
    //
    //   if (this.id !== 'NULL') {
    //     filterConditions.IdBulk = this.id
    //   }
    //
    //   this.$engine.get(this.engineIndex).tracking.getTracks(
    //     filterConditions
    //   )
    //   .then(resp => {
    //     let tracksList = {}
    //     if (resp.data && resp.data.tracks.length > 0) {
    //       tracksList = resp.data.tracks
    //     }
    //     that.updateTracksList(tracksList)
    //     that.activateSpinner = false
    //   })
    //   .catch(error => {
    //     that.activateSpinner = false
    //     errorMessageAlert(error, that)
    //   })
    // },
    hasProfileTrad (profileName) {
      let trad = this.$i18n.t('rights.db_profiles.' + profileName)
      if (trad === ('rights.db_profiles.' + profileName)) {
        return profileName
      }
      return trad
    },
    updateTracksList (trackList) {
      this.TracksList = trackList
    },
    // goBack () {
    //   const url = this.returnUrl
    //   if (url !== 'none') {
    //     loadPage(this, {url: url})
    //   } else {
    //     if (this.$f7.mainView.history[this.$f7.mainView.history.length - 2] === '/login/') {
    //       loadPage(this, {url: '/home/'})
    //     } else {
    //       if (this.$f7.mainView.history[this.$f7.mainView.history.length - 2] === this.$f7.mainView.history[this.$f7.mainView.history.length - 1]) {
    //         loadPage(this, {url: '/home/'})
    //       } else {
    //         this.$f7.mainView.router.back()
    //       }
    //       this.$bus.$emit('router-back')
    //     }
    //   }
    // },
    async exportLinesCSV() {
      this.activateSpinner = true;
      try {
        const engines = this.$engine?.engines ?? [];
        // purge des filtres résiduels
        for (let i = 0; i < engines.length; i++) {
          const engine = this.$engine.get(i);
          if (engine?.common?.network?.state !== 'offline' && engine?.tracking?.cleanFilterCondition) {
            engine.tracking.cleanFilterCondition();
          }
        }

        if (!this.paginationObject) this.paginationObject = {};
        this.pageCounter = 0;
        this.paginationObject.firstIndex = 1;
        this.paginationObject.nbResultsTotal = 0;

        // récupérer l’ID **du bulk** + type
        const bulkId = this.Tracking?.idTrackingBulk || this.id;
        const detectedType = this.Tracking?.Type || 'DDV';

        const filterConditions = {
          maxResults: this.paginationObject.maxResults,
          firstIndex: this.paginationObject.firstIndex,
          Type: detectedType,
          extract: 1,
          IdTrackBulk: bulkId,
        };

        const base64ToBytes = (b64) => {
          const bin = atob(b64);
          const out = new Uint8Array(bin.length);
          for (let i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i);
          return out;
        };
        const bytesToBase64 = (bytes) => {
          let bin = '';
          const chunk = 0x8000;
          for (let i = 0; i < bytes.length; i += chunk) {
            bin += String.fromCharCode.apply(null, bytes.subarray(i, i + chunk));
          }
          return btoa(bin);
        };
        const concatBytes = (arrays) => {
          const total = arrays.reduce((acc, a) => acc + a.length, 0);
          const out = new Uint8Array(total);
          let o = 0;
          arrays.forEach(a => { out.set(a, o); o += a.length; });
          return out;
        };
        const headerEndIndex = (bytes) => {
          let i = 0;
          if (bytes.length >= 3 && bytes[0] === 0xEF && bytes[1] === 0xBB && bytes[2] === 0xBF) i = 3; // BOM
          for (; i < bytes.length; i++) {
            if (bytes[i] === 0x0A) return i + 1;                   // LF
            if (bytes[i] === 0x0D) return (bytes[i+1] === 0x0A) ? i + 2 : i + 1; // CRLF/CR
          }
          return bytes.length;
        };
        const ensureEndsWithLF = (bytes) => {
          const n = bytes.length;
          if (n === 0) return new Uint8Array([0x0A]);
          if (bytes[n - 1] === 0x0A) return bytes;
          const out = new Uint8Array(n + 1);
          out.set(bytes);
          out[n] = 0x0A;
          return out;
        };

        let firstFileBytes = null;
        const bodies = [];

        for (let i = 0; i < engines.length; i++) {
          const engine = this.$engine.get(i);
          if (!engine || engine.common?.network?.state === 'offline') continue;
          if (!engine?.tracking?.getTracksBulk) continue;

          try {
            const resp = await engine.tracking.getTracksBulk(filterConditions);
            const b64 = resp?.data;
            if (!b64) continue;

            const bytes = base64ToBytes(b64);
            if (!firstFileBytes) {
              firstFileBytes = bytes; // garde header + BOM du premier silo
            } else {
              const cut = headerEndIndex(bytes);
              if (cut < bytes.length) bodies.push(bytes.subarray(cut)); // lignes sans header
            }
          } catch (err) {
            errorMessageAlert(err, this);
          }
        }

        if (!firstFileBytes) {
          this.$f7.hidePreloader();
          this.activateSpinner = false;
          this.$nextTick(() => this.$f7.alert('', this.$t('common.no_result')));
          return;
        }

        firstFileBytes = ensureEndsWithLF(firstFileBytes);

        const finalBytes = concatBytes([firstFileBytes, ...bodies]);
        const base64Final = bytesToBase64(finalBytes);
        const linkSource = 'data:text/csv;charset=utf-8;base64,' + base64Final;

        const fileName = this.$t('Webheader.tracking_bulk') + '_' + moment.tz().unix() + '.csv';

        if (this.$f7.device.os === 'android' || this.$f7.device.os === 'ios') {
          downloadFileWithDefinedHeaders(this, fileName, linkSource);
        } else {
          const a = document.createElement('a');
          a.href = linkSource;
          a.download = fileName;
          a.click();
        }

        this.$f7.hidePreloader();
        this.activateSpinner = false;
        this.$nextTick(() => this.$f7.alert('', this.$t('common.exprt_succ')));
      } catch (error) {
        this.$f7.hidePreloader();
        this.activateSpinner = false;
        errorMessageAlert(error, this);
      }
    }



  }
}

</script>
